module.exports = __webpack_public_path__ + "img/progress-icon.3272c413.svg";